const getSendPasswordRequest = state =>
  state.FSUPasswordRequired.sendPasswordRequest

export { getSendPasswordRequest }
